import { useState } from "react";

const WD = ["pn", "wt", "śr", "cz", "pt", "sb", "nd"];
const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const todayIso = () => iso(new Date());

const Month = ({ y, m, blocked, selected, onDay, adminMode }) => {
  const first = new Date(y, m, 1);
  const pad = (first.getDay() + 6) % 7;
  const days = new Date(y, m + 1, 0).getDate();
  const today = todayIso();
  return (
    <div className="cal-month">
      <p className="cal-title">{first.toLocaleDateString("pl-PL", { month: "long", year: "numeric" })}</p>
      <div className="cal-grid">
        {WD.map((w) => <span key={w} className="cal-wd">{w}</span>)}
        {Array.from({ length: pad }).map((_, i) => <span key={`p${i}`} />)}
        {Array.from({ length: days }).map((_, i) => {
          const d = iso(new Date(y, m, i + 1));
          const isB = blocked.includes(d);
          const past = d < today;
          const cls = `cal-day${isB ? " busy" : ""}${past ? " past" : ""}${selected === d ? " sel" : ""}`;
          return (
            <button key={d} type="button" className={cls} disabled={past || (!adminMode && isB)} onClick={() => onDay(d)} data-testid={`cal-day-${d}`} aria-label={`${d}${isB ? " zajęty" : ""}`}>
              {i + 1}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export const MonthCalendar = ({ blocked, selected, onDay, adminMode = false, months = 2 }) => {
  const now = new Date();
  const [off, setOff] = useState(0);
  const list = Array.from({ length: months }).map((_, i) => new Date(now.getFullYear(), now.getMonth() + off + i, 1));
  return (
    <div className="cal" data-testid="month-calendar">
      <div className="cal-nav">
        <button type="button" className="mini" disabled={off === 0} onClick={() => setOff(off - 1)} data-testid="cal-prev-btn">← Wcześniej</button>
        <button type="button" className="mini" onClick={() => setOff(off + 1)} data-testid="cal-next-btn">Później →</button>
      </div>
      <div className="cal-months">
        {list.map((d) => <Month key={iso(d)} y={d.getFullYear()} m={d.getMonth()} blocked={blocked} selected={selected} onDay={onDay} adminMode={adminMode} />)}
      </div>
      <div className="cal-legend"><span><i className="dot free" />wolny</span><span><i className="dot busy" />zajęty</span>{selected && <span><i className="dot sel" />wybrany</span>}</div>
    </div>
  );
};
